import React, { useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";
import { API, graphqlOperation } from "aws-amplify";
import { Modal, Card } from "react-bootstrap";
import { usePlaidLink } from "react-plaid-link";

import AutomaticPayment from "./components/AutomaticPayment";
import CardAccount from "./components/CardAccount";
import { SpinnerLoading } from "../../components/Loadings";
import { useTable, useSortBy } from "react-table";

import { createPlaidLink, deleteDwollaFundingSource } from "../../graphql/mutations";
import {
  getPlaidAccessToken,
  getPlaidAccounts,
  getDwollaProcessorToken,
  getPlaidBankLogos,
} from "../../graphql/queries";

import { Context } from "../../Utility/ContextManager";
import envFile from "../../envFile";
import { fetchAllBankAccounts, fetchFuturePayments, updateRecordTB } from "../../Utility/ApiService";
import { confirmAlert } from "react-confirm-alert";
import { useconfirmAlert } from "../../Utility/Confirmation";
import AddBankAccount from "./components/AddBankAccount";
import UpcomingTransactions from "./components/UpcomingTransactions";
import ManageBankInfo from "./components/ManageBankInfo";

function BankAccount() {
  const { user, bankAccounts, setBankAccounts, setPlaidToken } = useContext(Context);
  const [oldDefaultAccount, setOldDefaultAccount] = useState();
  const [loading, setLoading] = useState(true);
  const [showNoDeleteInfoModal, setShowNoDeleteInfoModal] = useState(false);
  const [showUserInfoModal, setShowUserInfoModal] = useState(false);
  const [upcomingPayments, setUpcomingPayments] = useState([]);
  const [verifyAccount, setVerifyAccount] = useState(null);
  const [verificationToken, setVerificationToken] = useState("");
  const [showLastAccountWarningModal, setShowLastAccountWarningModal] = useState(false);
  const [lastAccountToDelete, setLastAccountToDelete] = useState(null);
  const [removalCheckboxChecked, setRemovalCheckboxChecked] = useState(false);

  const { open } = usePlaidLink({
    token: verificationToken,
    onSuccess: (public_token, metadata) => {
      addBankAccount(metadata);
    },
  });
  useEffect(() => {
    getAllBankAccounts();
    getFuturePayments();
  }, []);

  useEffect(() => {
    if (user?.cognito_user_id) {
      const obj = {
        userId: user?.cognito_user_id,
        userName: envFile.PLAID_USERNAME,
      };
      API.graphql(graphqlOperation(createPlaidLink, obj))
        .then((res) => {
          setPlaidToken(res?.data?.createPlaidLink?.response);
        })
        .catch((err) => {
          console.log("err createPlaidLink tiken ", err);
        });
    }
  }, [user?.cognito_user_id]);

  useEffect(() => {
    if (verifyAccount) {
      setLoading(true);
      API.graphql(
        graphqlOperation(createPlaidLink, {
          userId: user?.cognito_user_id,
          userName: envFile.PLAID_USERNAME,
          accessToken: verifyAccount?.plaid_access_token,
        })
      )
        .then((res) => {
          setVerificationToken(res.data.createPlaidLink.response);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.log("err createPlaidLink tiken ", err);
        });
    }
  }, [verifyAccount]);

  const handleClose = () => {
    setVerificationToken("");
    setVerifyAccount(null);
  };
  const removeAutomaticPayment = async () => {
    try {
      setLoading(true);

      const isExit = upcomingPayments?.find((item) => item.repeat_payment === 1);
      if (isExit) {
        const bankAccountObj = {
          id: isExit?.id,
          repeat_payment: 0,
          active: 0,
        };
        const res = await updateRecordTB("PropertyLeasePayment", bankAccountObj);
        const hasAutoPayment = upcomingPayments?.find((transaction) => transaction?.repeat_payment === 1);
        getFuturePayments();
        if (res) {
          if (hasAutoPayment) {
            toast.success("Transaction successfully deleted and Auto payment has been disabled for this account");
          } else {
            toast.success("Transaction successfully deleted");
          }
          getAllBankAccounts();
        }
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("cancel auto payment error  ", error);
      toast.error("Something went wrong");
    }
  };

  const addBankAccount = async (metadata) => {
    try {
      const { public_token, account } = metadata;
      setLoading(true);
      const res = await API.graphql(
        graphqlOperation(getPlaidAccessToken, {
          publicToken: public_token,
        })
      );
      const AccessToken = res.data.getPlaidAccessToken.response;
      let accountObj = {};
      if (account?.verification_status === "manually_verified") {
        let resData = await API.graphql(
          graphqlOperation(getPlaidAccounts, {
            accessToken: AccessToken,
          })
        );
        resData = JSON.parse(resData.data.getPlaidAccounts.response);

        const AccountId = resData.accounts[0].account_id;
        const AccountName = resData.accounts[0].name;
        // const AccountType = resData.accounts[0].type;
        const InstituteId = resData.item.institution_id;
        const Routing_number = resData.numbers.ach[0].routing;

        // const resGetPlaidInstitution = await API.graphql(
        //   graphqlOperation(getPlaidInstitution, {
        //     institutionId: InstituteId,
        //   })
        // );
        // const parsedResponse = JSON.parse(resGetPlaidInstitution?.data?.getPlaidInstitution?.response);
        // const bank_name = parsedResponse?.institution?.name;
        // // const bank_name = await getBankName(InstituteId);
        // if (!bank_name) {
        //   toast.error("Something went wrong please try later");
        //   return;
        // }

        const customerUrl = `${envFile.DwOLLA_API_URL}/customers/${user?.dwolla_customer_id}`;
        const getFundingId = await API.graphql(
          graphqlOperation(getDwollaProcessorToken, {
            accessToken: AccessToken,
            accountId: AccountId,
            bankName: AccountName,
            customerUrl,
          })
        );
        if (
          getFundingId.data.getDwollaProcessorToken.status !== 200 &&
          getFundingId.data.getDwollaProcessorToken.status !== 201
        ) {
          // toast.error(getFundingId.data.getDwollaProcessorToken.response.split(":")[0]);
          toast.error("Bank already exists");
          setLoading(false);
          return;
        }

        const fundingId = getFundingId.data.getDwollaProcessorToken.response;

        accountObj = {
          id: verifyAccount?.id,
          routing_number: Routing_number,
          tenant_id: user.id,
          dwolla_funding_id: fundingId,
          status: account?.verification_status,
        };
      }

      await updateRecordTB("TenantBankAccount", accountObj);
      handleClose();
      getAllBankAccounts();
      setLoading(false);
    } catch (error) {
      console.log(error, "jhjhh");
      setLoading(false);
    }
  };

  const getAllBankAccounts = async () => {
    try {
      setLoading(true);
      const data = await fetchAllBankAccounts({ tenant_id: user?.id });

      const bankAccounts = await getBankAccountPhotos(data);
      const allBankAccountsWithPic = bankAccounts?.filter((bankAccount) => bankAccount.active === 1);
      for (let i = 0; i < allBankAccountsWithPic.length; i++) {
        if (allBankAccountsWithPic[i]?.default_bank_account === 1) {
          setOldDefaultAccount(allBankAccountsWithPic[i]);
        }
      }
      setBankAccounts(allBankAccountsWithPic);
      setLoading(false);
    } catch (error) {
      console.log("error getAllBankAccounts ", error);
      setLoading(false);
      toast.error(error.errorMessage || error.message || error);
    }
  };

  const getFuturePayments = async () => {
    try {
      const res = await fetchFuturePayments({ tenant_id: user?.id });
      const filteredRes = res.filter((item) => item?.member_auto_payment !== 1);
      setUpcomingPayments(filteredRes.slice(0, 50));
      return res;
      //console.log("res", res);
    } catch (error) {
      console.log(error);
    }
  };

  const getBankAccountPhotos = (bankAccounts) => {
    return Promise.all(
      bankAccounts?.map((bankAccount) => {
        if (bankAccount.bankLogo !== null) {
          return new Promise((resolve) => {
            API.graphql(
              graphqlOperation(getPlaidBankLogos, {
                insitutionID: bankAccount?.institution_id,
              })
            ).then((result) => {
              var newBankAccount = Object.assign({}, bankAccount);
              let res = result.data.getPlaidBankLogos.response;
              newBankAccount.bankLogo = res;
              resolve(newBankAccount);
            });
          });
        } else {
          return new Promise((resolve) => {
            var newBankAccount = Object.assign({}, bankAccount);
            let res = "https://foliolens160827-dev.s3.amazonaws.com/public/property/house.jpeg";
            newBankAccount.bankLogo = res;
            resolve(newBankAccount);
          });
        }
      })
    );
  };

  const updateDefaultAccount = (newAccount) => {
    makeUpdateOrDelete(newAccount, false);
  };

  const isAutoPayOn = upcomingPayments?.some((payment) => payment.repeat_payment === 1);

  const handleDelete = (item) => {
    const activeBankAccounts = bankAccounts?.filter((b) => b.active === 1);
    if (activeBankAccounts?.length === 1) {
      setLastAccountToDelete(item);
      setRemovalCheckboxChecked(false);
      setShowLastAccountWarningModal(true);
    } else if (item?.default_bank_account === 1) {
      setShowNoDeleteInfoModal(true);
    } else {
      confirmAlert({
        overlayClassName: "confirm-alert--lg",
        customUI: ({ onClose }) => (
          <div className="custom-ui">
            <div className="text-center" style={{ marginBottom: 16, fontSize: "24px", fontWeight: 600 }}>
              Confirm Bank Account Removal
            </div>
            <h6 style={{ marginBottom: 20 }}>
              This will cancel your future automatic payments using this bank account, are you sure?
            </h6>
            <div className="row" style={{ marginTop: 20 }}>
              <div className="col-6">
                <button onClick={onClose} type="submit" className="btn btn-warning w-100">
                  Cancel
                </button>
              </div>
              <div className="col-6">
                <button
                  onClick={() => {
                    makeUpdateOrDelete(item, true);
                    onClose();
                  }}
                  type="submit"
                  className="btn btn-primary w-100"
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        ),
      });
    }
  };

  const makeUpdateOrDelete = async (account, deleteAcount) => {
    try {
      setLoading(true);
      const bankAccountObj = {
        id: account.id,
        nick_name: account?.nick_name,
        default_bank_account: account.default_bank_account,
        ...(deleteAcount === true && { active: 0 }),
      };
      await updateRecordTB("TenantBankAccount", bankAccountObj);
      if (deleteAcount === true) {
        await API.graphql(
          graphqlOperation(deleteDwollaFundingSource, {
            sourceId: account.dwolla_funding_id,
          })
        );
      }
      getAllBankAccounts();
    } catch (error) {
      console.log("makeDefault error  ", error);
      setLoading(false);
    }
  };

  const handleCancelAutoPayment = async (account) => {
    try {
      setLoading(true);
      const bankAccountObj = {
        id: account.property_lease_payment_id,
        repeat_payment: 0,
      };
      await updateRecordTB("PropertyLeasePayment", bankAccountObj);
      getAllBankAccounts();
      getFuturePayments();
    } catch (error) {
      setLoading(false);
      console.log("cancel auto payment error  ", error);
    }
  };

  const columns = React.useMemo(
    () => [
      {
        Header: "Account Name/Nick Name",
        accessor: (row) => (
          <div>
            <img
              src={row?.bankLogo}
              style={{ height: "45px", width: "45px", borderRadius: "50%", marginLeft: "22px" }}
              alt=""
              onError={({ currentTarget }) => {
                currentTarget.onerror = null; // prevents looping
                currentTarget.src = require("../../assets/images/icon-bank-black.svg").default;
              }}
            />
            <div style={{ display: "inline-flex" }}>
              <span style={{ marginLeft: "10px" }}>{`${row?.nick_name || row?.bank_name || ""}`}</span>
              <>
                {row?.default_bank_account === 1 && (
                  <span style={{ marginLeft: "10px", fonSize: "13px" }} className="default-tag">
                    {"Default"}
                  </span>
                )}
                <span
                  style={{ marginLeft: "5px", marginTop: "2px" }}
                  className={`${
                    row?.status === "verified" || row?.status === "manually_verified" ? "" : "un"
                  }verified-account`}
                >
                  {row?.status === "verified" || row?.status === "manually_verified" ? "Verified" : "Unverified"}

                  {/*<img
                      style={{ maxHeight: "18px", marginBottom: "3px", marginLeft: "5px" }}
                      src={
                        row?.status === "verified" || row?.status === "manually_verified"
                          ? require("../../assets/images/icon-check-green.svg").default
                          : require("../../assets/images/icon-exclamation-red.svg").default
                      }
                      alt=""
                    />*/}
                </span>
              </>
            </div>
          </div>
        ),
      },
      {
        Header: "Bank Name",
        accessor: (row) => row?.bank_name,
      },
      {
        Header: "Routing Number",
        accessor: (row) => <span>{`XXXXX` + row?.routing_number?.substring(row?.routing_number?.length - 4)}</span>,
      },
      {
        Header: "Account Number",
        accessor: (row) => <span>{<span>{`XXXXXX` + row?.account_number}</span>}</span>,
      },
      {
        Header: " ",
        accessor: (row) => (
          <div className="dropdown text-end" style={{ height: "60px" }}>
            <button
              className="btn dropdown-toggle"
              type="button"
              id="dropdownMenuButton1"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <img src={require("../../assets/images/toggle-btn.svg").default} alt="" />
            </button>
            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
              {row?.status !== "verified" && row?.status !== "manually_verified" && (
                <li className="dropdown-item" onClick={() => setVerifyAccount(row)}>
                  <img
                    style={{ maxHeight: "12px" }}
                    src={require("../../assets/images/icon-check-green.svg").default}
                  />
                  <span className={`text-success`}>Verify</span>
                </li>
              )}
              <ManageBankInfo
                selected={row?.default_bank_account === 1 ? "Default" : ""}
                updateDefaultAccount={updateDefaultAccount}
                item={row}
                oldDefaultAccount={oldDefaultAccount}
              />
              <li className="dropdown-item" onClick={() => handleDelete(row)}>
                <img src={require("../../assets/images/delete.svg").default} />
                <span className={`text-danger`}>Delete</span>
              </li>
            </ul>
          </div>
        ),
      },
    ],
    [oldDefaultAccount, bankAccounts]
  );
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable(
    {
      columns,
      data: bankAccounts || [],
    },
    useSortBy
  );
  const TableView = () => {
    return (
      <div className="table-responsive">
        <table
          {...getTableProps()}
          className="table customise-table cell-border w-100"
          // style={
          //   {
          //     /*minHeight: 250*/
          //   }
          // }
        >
          <thead>
            {headerGroups?.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                    {column.render("Header")}
                    <span style={{ color: "#8C8C8C", marginLeft: "12px" }}>
                      {column.isSorted ? (
                        column.isSortedDesc ? (
                          <i className="fa fa-caret-down"></i>
                        ) : (
                          <i className="fa fa-caret-up"></i>
                        )
                      ) : (
                        ""
                      )}
                    </span>
                  </th>
                ))}
              </tr>
            ))}
          </thead>
          <tbody {...getTableBodyProps()}>
            {rows.map((row, index) => {
              prepareRow(row);
              return (
                <React.Fragment key={row.id || index}>
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => {
                      return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>;
                    })}
                    {index === rows.length - 1 && <div style={{ height: "175px" }}></div>}
                  </tr>
                </React.Fragment>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  };
  const CardView = () => {
    return (
      <div className="table-responsive ml-4">
        <Card>
          <Card.Body>
            {bankAccounts?.map((item, index) => {
              return (
                <CardAccount
                  key={index}
                  item={item}
                  selected={item?.default_bank_account === 1 ? "Default" : ""}
                  updateDefaultAccount={updateDefaultAccount}
                  handleDelete={handleDelete}
                  oldDefaultAccount={oldDefaultAccount}
                  setVerifyAccount={setVerifyAccount}
                />
              );
            })}
          </Card.Body>
        </Card>
      </div>
    );
  };
  return (
    <div>
      {/* START layout-wrapper */}
      <div>
        {loading && (
          <div className="loadingSpinner">
            <SpinnerLoading />
          </div>
        )}
        <div>
          {/* START page title */}
          <div className="row">
            <div className="col-xl-5 col-lg-4">
              <div className="page-title d-flex align-items-center">
                <h2>Bank Account</h2>
                {user?.status === "SUSPENDED" && <span className="past-due-label">Suspended</span>}
              </div>
            </div>
            <div className="col-xl-7 col-lg-8"></div>
          </div>
          <div className="row eq-col bank-account">
            {(user?.dwolla_customer_id && user?.status === "NULL") ||
              (user?.status === "DOCUMENT" && (
                <p>
                  Dwolla is verifying your information, you will be able to make online payments once your account is
                  verified.
                </p>
              ))}
            {user?.status === "SUSPENDED" && (
              <p className="text-danger">
                Dwolla was unable to verify your information even on 2nd attempt. You will not be able to make online
                payments, please contract your Landlord/Property Manager.
              </p>
            )}
            {user?.status === "REVERIFICATION" && (
              <p>
                Dwolla was unable to verify your information.{" "}
                <a className="" onClick={() => setShowUserInfoModal(true)}>
                  Click here
                </a>{" "}
                to re-submit.
              </p>
            )}
            {/* SUSPENDED */}
            <div className="block col-xl-8 col-md-12 add-bank-button w-100">
              <div className="card">
                <AddBankAccount
                  setLoading={setLoading}
                  getAllBankAccounts={getAllBankAccounts}
                  showUserInfoModal={showUserInfoModal}
                  setShowUserInfoModal={setShowUserInfoModal}
                  loading={loading}
                />
              </div>
            </div>
            {rows?.length > 0 ? (
              <>
                <div className="ml-4 d-none d-md-block">
                  <TableView />
                </div>
                <div className="d-md-none">
                  <CardView />
                </div>
              </>
            ) : (
              <div className="no-data-found text-center">
                <div className="svg-frame">
                  <img src={require("../../assets/images/frame.svg").default} alt="frame" />
                </div>
                <p>So far, you have not added any accounts.</p>
              </div>
            )}
            {/*bankAccounts?.map((item, index) => {
              return (
                <CardAccount
                  key={index}
                  item={item}
                  selected={item?.default_bank_account === 1 ? "Default" : ""}
                  updateDefaultAccount={updateDefaultAccount}
                  handleDelete={handleDelete}
                  oldDefaultAccount={oldDefaultAccount}
                  setVerifyAccount={setVerifyAccount}
                />
              );
            })*/}
          </div>
          {/*upcomingPayments?.find((transaction) => transaction?.repeat_payment === 1) && (
            <AutomaticPayment
              bankAccounts={bankAccounts}
              handleDelete={removeAutomaticPayment}
              updateDefaultAccount={updateDefaultAccount}
              oldDefaultAccount={oldDefaultAccount}
              cancelAutoPayment={handleCancelAutoPayment}
              upcomingPayments={upcomingPayments}
            />
          )*/}
          {/*upcomingPayments?.length > 0 && (
            <UpcomingTransactions
              upcomingTransactions={upcomingPayments}
              setLoading={setLoading}
              getFuturePayments={getFuturePayments}
              bankAccounts={bankAccounts}
            />
          )*/}
        </div>

        <Modal
          className="modal-style-1 w-100 pd-md"
          centered
          show={showNoDeleteInfoModal}
          onHide={() => setShowNoDeleteInfoModal(false)}
        >
          <Modal.Body>
            <div className="d-flex justify-content-end">
              <i
                className="fa fa-times-circle cursor-pointer"
                onClick={() => setShowNoDeleteInfoModal(false)}
                style={{ fontSize: "25px" }}
              />
            </div>
            <div className="text-center" style={{ marginBottom: 30, fontSize: "24px", fontWeight: 600 }}>
              Cannot Remove Default Account
            </div>
            <div className="d-flex mt-3">
              {`You cannot delete this account as this is the default account.
               Please set another account as default  before deleting this account`}
            </div>
          </Modal.Body>
        </Modal>

        <Modal
          className="modal-style-1 w-100 pd-md"
          centered
          show={showLastAccountWarningModal}
          onHide={() => {
            setShowLastAccountWarningModal(false);
            setRemovalCheckboxChecked(false);
          }}
        >
          <Modal.Body>
            <div className="d-flex justify-content-end">
              <i
                className="fa fa-times-circle cursor-pointer"
                onClick={() => {
                  setShowLastAccountWarningModal(false);
                  setRemovalCheckboxChecked(false);
                }}
                style={{ fontSize: "25px" }}
              />
            </div>
            <div className="text-center" style={{ marginBottom: 30, fontSize: "24px", fontWeight: 600 }}>
              Confirm Bank Account Removal
            </div>
            <div className="text-center mb-4">
              This is your only bank account. Removing it will disable payments through this portal.
              {isAutoPayOn && (
                <> If AutoPay is on, turn it off first otherwise payments may fail and incur NSF fees.</>
              )}
            </div>
            <div className="d-flex align-items-center mb-4">
              <input
                type="checkbox"
                id="removal-confirm-checkbox"
                checked={removalCheckboxChecked}
                onChange={(e) => setRemovalCheckboxChecked(e.target.checked)}
                style={{ marginRight: 10, cursor: "pointer", width: 16, height: 16 }}
              />
              <label htmlFor="removal-confirm-checkbox" style={{ marginBottom: 0, cursor: "pointer" }}>
                I understand and want to remove this bank account.
              </label>
            </div>
            <div className="row">
              <div className="col-6">
                <button
                  className="btn btn-warning w-100"
                  onClick={() => {
                    setShowLastAccountWarningModal(false);
                    setRemovalCheckboxChecked(false);
                  }}
                >
                  Cancel
                </button>
              </div>
              <div className="col-6">
                <button
                  className="btn btn-primary w-100"
                  disabled={!removalCheckboxChecked}
                  onClick={() => {
                    setShowLastAccountWarningModal(false);
                    setRemovalCheckboxChecked(false);
                    makeUpdateOrDelete(lastAccountToDelete, true);
                  }}
                >
                  Confirm
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>

        <Modal className="modal-style-1 w-100 pd-md" centered show={!!verifyAccount} onHide={() => handleClose()}>
          <Modal.Body>
            <div className="d-flex justify-content-end">
              <i
                className="fa fa-times-circle cursor-pointer"
                onClick={() => handleClose()}
                style={{ fontSize: "25px" }}
              />
            </div>
            <div className="text-center" style={{ marginBottom: 30, fontSize: "24px" }}>
              Verify Bank Account
            </div>
            <div className="card">
              <div className="card-body">
                <div className="d-flex mb-3">
                  <div className="d-flex align-items-center" style={{ lineHeight: 1.2 }}>
                    <span className="bank-name">{verifyAccount?.nick_name}</span>
                  </div>
                </div>
                <ul className="list-unstyled bank-details mb-0">
                  <li>
                    <span>{`XXXXXX` + verifyAccount?.account_number}</span> (Unverified)
                  </li>
                </ul>
              </div>
            </div>

            <div
              className="row"
              style={{
                marginTop: 20,
              }}
            >
              <div className="col-6">
                <button onClick={() => handleClose()} type="submit" className="btn btn-warning w-100">
                  Cancel
                </button>
              </div>
              <div className="col-6">
                <button
                  onClick={() => {
                    open();
                  }}
                  type="submit"
                  className="btn btn-primary w-100"
                  disabled={!verificationToken}
                >
                  {verificationToken ? "Verify" : "Loading..."}
                </button>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
}

export default BankAccount;
